<template>
  <VendorBlock
    theme="grey"
    class="vendor-speakers"
  >
    <template #title>
      {{ title }}
    </template>

    <template #content>
      <div class="vendor-speakers__content">
        <ul class="vendor-speakers__list">
          <li
            v-for="(speaker, i) in slicedAuthors"
            :key="i"
            class="vendor-speakers__item"
          >
            <UiAuthor
              :author="speaker"
              class="vendor-speakers__card"
            />
          </li>
        </ul>

        <UiButton
          v-if="speakers.length > 2"
          theme="quaternary"
          size="big"
          stretch
          @click="isExpanded = !isExpanded"
        >
          {{ isExpanded ? 'Скрыть' : 'Показать ещё' }}
        </UiButton>
      </div>
    </template>
  </VendorBlock>
</template>

<script setup lang="ts">
  import type { Author } from '@academica-box/components/Blocks/UiAuthor/types'
  import UiButton from '@academica-box/components/Buttons/UiButton/UiButton.vue'
  import UiAuthor from '@academica-box/components/Blocks/UiAuthor/UiAuthor.vue'
  import VendorBlock from '@/components/Vendor/VendorBlock.vue'

  const props = defineProps<{
    title: string;
    speakers: Author[];
  }>()

  const isExpanded = ref(false)

  const slicedAuthors = computed(() => {
    return isExpanded.value ? props.speakers : [...props.speakers].splice(0, 2)
  })
</script>

<style lang="scss">
  @use '@academica-box/utils/styles/mixins/UiReset' as *;
  @use '@academica-box/utils/styles/mixins/UiMedia' as *;

  .vendor-speakers__list {
    @include ulres;

    @include media(md, md-max) {
      display: grid;
      grid-gap: 6px;
      grid-template-columns: 1fr 1fr;
    }

    &:not(:last-child) {
      margin-bottom: 20px;

      @include media(lg) {
        margin-bottom: 32px;
      }
    }
  }

  .vendor-speakers__item {
    &:not(:last-child) {
      margin-bottom: 6px;

      @include media(md) {
        margin-bottom: 0;
      }

      @include media(lg) {
        margin-bottom: 16px;
      }
    }
  }

  .vendor-speakers__card {
    height: 100%;
  }
</style>
